function LoyJoyWrapper(el) {
  this.el = el;
  this.init();
}
LoyJoyWrapper.prototype.init = function() {

  this.info = this.el.querySelector('.js-info');
  this.button1 = this.el.querySelector('.js-button-1');
  this.button1.addEventListener('click', this.onClick1.bind(this));
  this.button2 = this.el.querySelector('.js-button-2');
  this.button2.addEventListener('click', this.onClick2.bind(this));
  this.buttonClose = this.el.querySelector('.js-button-close');
  this.buttonClose.addEventListener('click', this.onClickClose.bind(this));
  this.input = this.el.querySelector('.js-input');

  if (window.BorlabsCookie && window.BorlabsCookie.checkCookieConsent('loyjoy')) {
    this.hadCookieConsent = true;
  }

  setInterval(this.onInterval.bind(this), 1000);
}

LoyJoyWrapper.prototype.onClick1 = function() {
  if (window.BorlabsCookie) {
    // show info box about privacy policy
    this.info.classList.remove('hidden');
  }
}

LoyJoyWrapper.prototype.onClick2 = function() {
  if (window.BorlabsCookie) {
    if (this.input.checked && window.BorlabsCookie) {
      window.BorlabsCookie.addConsent('external-media', 'loyjoy');
      this.hadCookieConsent = true;
    }
    this.hideOptIn();
    this.hasSessionConsent = true;
    this.initScript(true);
  }
}

LoyJoyWrapper.prototype.onClickClose = function() {
  this.info.classList.add('hidden');
}

LoyJoyWrapper.prototype.onInterval = function() {
  if (window.BorlabsCookie) {
    // store if we had cookie consent at one time
    if (window.BorlabsCookie.checkCookieConsent('loyjoy')) {
      this.hadCookieConsent = true;
    }
    // if we have cookie consent stored but not initialized the script yet, then initialize
    if (window.BorlabsCookie.checkCookieConsent('loyjoy') && !this.scriptInitialized) {
      this.hideOptIn();
      this.initScript();
    }
    // if we had cookie consent given during a session but lost it, then remove the script
    if (!window.BorlabsCookie.checkCookieConsent('loyjoy') && this.hadCookieConsent) {
      if (this.scriptInitialized) {
        var script = document.head.querySelector('[src="https://stable.loyjoy.com/widget/widget.js?651805ea-44bd-4ddd-9467-91c35a935c90"]');
        if (LoyJoy) LoyJoy('remove');
        if (script) script.remove();
        this.scriptInitialized = false;
      }
      this.hasSessionConsent = false;
      this.hadCookieConsent = false;
    }
    // show the chat bot optin only after borlabs has loaded and no consent was given
    if (!window.BorlabsCookie.checkCookieConsent('loyjoy') && !this.hasSessionConsent) {
      this.el.classList.remove('hidden');
    }
  }
}

LoyJoyWrapper.prototype.hideOptIn = function() {
  this.info.classList.add('hidden');
  this.el.classList.add('hidden');
}

LoyJoyWrapper.prototype.initScript = function(openAfterLoad) {
  if (this.scriptInitialized) return;
  var widget = document.createElement('script');
  widget.src = "https://stable.loyjoy.com/widget/widget.js?651805ea-44bd-4ddd-9467-91c35a935c90";
  widget.referrerPolicy = "no-referrer";
  if (openAfterLoad) {
    widget.addEventListener('load', function() {
      LoyJoy('boot', {
        eventListeners: [
          function(type, details) {
            if (type === 'load') {
              LoyJoy('open')
            }
          }
        ],
        process: '651805ea-44bd-4ddd-9467-91c35a935c90'
      });
    })
  } else {
    widget.addEventListener('load', function() {
      LoyJoy('boot', {
        process: '651805ea-44bd-4ddd-9467-91c35a935c90'
      });
    })
  }
  document.head.appendChild(widget);
  this.scriptInitialized = true;
  this.el.classList.add('hidden');
}

Array.prototype.forEach.call(document.querySelectorAll('.loyjoy-wrapper'), function(el) {
  new LoyJoyWrapper(el);
});